// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1qXwM","footer":"ModalFilter_footer__XSpUG"};